import {SeedDataConfig} from 'analysis-tool/create-analysis-modal/SeedDataTypes';
import * as net from 'util/Net';
import {OngoingTaskResponse} from 'util/TaskRunner';
import {JSONValue} from 'util/Types';

export interface CreateAnalysisParams {
  folderId: string;
  name: string;
  seedDataConfig?: SeedDataConfig;
  studyIds?: Array<string>;
  templateRun?: {
    templateId: string;
    variableBindings?: Array<{variableId: string; variableValue: JSONValue}>;
  };
}

export interface CreateAnalysisResponse {
  analysisId: string;
  seedAnalysisTask?: OngoingTaskResponse | null;
}

export function createAnalysis(data: CreateAnalysisParams): Promise<CreateAnalysisResponse> {
  return net.postJSONPromise({url: '/1/api/analyses', data});
}

export interface UpdateAnalysisParentParams {
  folderId?: string;
}
export type UpdateAnalysisParams = {
  name?: string;
} & UpdateAnalysisParentParams;

export interface UpdateAnalysisResponse {
  analysisId: string;
}

export function updateAnalysis(
  analysisId: string,
  data: UpdateAnalysisParams
): Promise<UpdateAnalysisResponse> {
  return net.patchJSONPromise({
    url: `/1/api/analyses/${analysisId}`,
    data,
  });
}

export interface CloneAnalysisParams {
  folderId: string;
}

export interface CloneAnalysisResponse {
  newAnalysisId: string;
}

export function cloneAnalysis(analysisId: string, data: CloneAnalysisParams): Promise<CloneAnalysisResponse> {
  return net.postJSONPromise({url: `/1/api/analyses/${analysisId}:clone`, data});
}
